export default __webpack_public_path__ + "static/media/interface.b912bf4c.svg";